import gql from 'graphql-tag';

export const CreateDispatchSummaryMarket = gql`
  mutation CreateDispatchSummaryMarketBulk($input: CreateDispatchSummaryMarketBulkInput!) {
    createDispatchSummaryMarketBulk(input: $input) {
      output {
        error
        node {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          dispatchSummaryId
          comment
          airportCode
        }
      }
    }
  }
`;
